import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Navbar from "./components/navbar";
import Operations from "./screens/operations";
import Dataentry from "./screens/dataentry";
import ManageScreens from "./screens/manageScreens";
import ManageScreen from "./screens/manageScreen";
import Dashboards from "./screens/dashboards";
import Reports from "./screens/Reports";
import Grabber from "./screens/grabber";
import ManageDashboards from "./components/manageDashboards";
import ManageDashboard from "./components/manageDashboard";
import ManageReports from "./components/manageReports";
import ManageReport from "./components/manageReport";
import ManageGrabbers from "./components/manageGrabbers";
import ManageGrabber from "./components/manageGrabber";
import Parameter from "./screens/Parameter";
import Parameters from "./components/parameters";
import ParameterEdit from "./components/ParameterEdit";
import ParameterForm from "./components/parameterForm";
import Constants from "./components/constants";
import Lookups from "./components/lookups";
import Users from "./screens/Users";
import UserForm from "./components/userForm";
import Reset from "./components/reset-password";
import Login from "./components/login";
import Logout from "./components/logout";
import Profile from "./components/profile";
import Twitter from "./screens/Twitter";
import ProcessTags from "./components/processTags";
import Home from "./screens/home";
import Sidebar from "./components/sidebar";
import Recalculate from "./components/recalculate";
import ProtectedRoute from "./components/common/protectedRoute";
import NotFound from "./components/not-found";
import auth from "./services/authService";
import ResetForm from "./components/resetForm";
import DataSummary from "./components/dataSummary";
import Notifications from "./screens/Notifications";
import LiveData from "./screens/LiveData";
import Privacy from "./screens/Privacy";
import CCFList from "./screens/CCFList";
import CCF from "./screens/CCF";
import SiteModal from "./components/SiteModal";
import CookieConsent from "./components/common/CookieConsent";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "./App.css";
import http from "./services/http";

import UserContext from "./context/userContext";
import SidebarContext from "./context/sidebarContext";
import AppearanceContext from "./context/appearanceContext";
import NotificationContext from "./context/notificationContext";
import useNotifications from "./hooks/notifications";
import HelpHome from "./screens/help/Home";
import AppSupport from "./screens/Support";
import Register from "./screens/Register";
import CCFSettings from "./screens/CCFSettings";
import { isPageReload } from "./utils/common/utils";

const App = () => {
  const [user, setUser] = useState("");
  const [sidebar, setSidebar] = useState(true);
  const [appearance, setAppearance] = useState("light");
  const [showSiteSelection, setShowSiteSelection] = useState(false);
  const [showCookie, setShowCookie] = useState(false);
  const [ccf, setCcf] = useState([]);

  const { pathname } = useLocation();

  const tokenKey = "ftr-token";
  
  useEffect(() => {
    const user = auth.getCurrentUser();
    setUser(user);
  }, []);

  function logout() {
    let rememberMe = localStorage.getItem("ftr-remember-me");
    rememberMe = rememberMe === "true" ? true : false;

    if (!rememberMe) {
      try {
        http.delete("/auth");

        localStorage.removeItem(tokenKey);
        sessionStorage.removeItem(tokenKey);
      }
      catch {
        //ignore error
      }
    }
  }

  useEffect(() => {
    const cookieConsent = localStorage.getItem("ftr-cookie-consent");
    if (!cookieConsent) setTimeout(() => setShowCookie(true), 1500);
  }, []);

  function handleToggle() {
    setSidebar(!sidebar);
  }

  useEffect(() => {
    async function getCCFSummary() {
      updateCcfSummary();
    }

    if (auth.getToken()) {
      getCCFSummary();
    }
  }, []);

  async function updateCcfSummary() {
    try {
      if (window.location.pathname === '/login' || window.location.pathname === '/logout') return;
      
      const { data: ccfSummary } = await http.get(`/ccf-summary`);
      setCcf(ccfSummary);
    }
    catch {
      //ignore error
    }
  }

  const notifications = useNotifications(user);

  const handleSiteClick = () => {
    setShowSiteSelection(true);
  };

  const handleSiteChange = async (site) => {
    try {
      const { data } = await http.post(`/auth/change-site/${site}`);
      auth.updateToken(data);

      const currentPath = window.location;
      if (currentPath.pathname.slice(0, 10) === "/dataentry" && currentPath.pathname.length > 10) window.location = "/dataentry";
      else window.location.reload(true);
    } catch (ex) {
      if (ex.response) {
        var message = "An unexpected error occurred.";

        if (ex.response.message) message = ex.response.message;
        else if (ex.response.statusText) {
          message = ex.response.statusText;

          if (ex.response.data) message += ': ' + ex.response.data;
        }

        toast.error(message);
      }
    }
  };

  const handleAcceptCookies = () => {
    localStorage.setItem("ftr-cookie-consent", "accepted");
    setShowCookie(false);
  };

  let SidebarComponent = Sidebar;

  if (
    pathname.split("/")[1].toLowerCase() === "login" ||
    pathname.split("/")[1].toLowerCase() === "privacy" ||
    pathname.split("/")[1].toLowerCase() === "app-help" ||
    pathname.split("/")[1].toLowerCase() === "register" ||
    pathname.split("/")[1].toLowerCase() === "reset"
  )
    SidebarComponent = () => {
      return null;
    };

  return (
    <UserContext.Provider value={[user, setUser]}>
      <SidebarContext.Provider value={[sidebar, setSidebar]}>
        <AppearanceContext.Provider value={[appearance, setAppearance]}>
          <NotificationContext.Provider value={notifications}>
            <div className="container-fluid">
              <ToastContainer />
              <Navbar handleSiteClick={handleSiteClick} />
              <div className="row">
                <SidebarComponent handleToggle={handleToggle} ccf={ccf} />
                <Switch>
                  <ProtectedRoute
                    exact path="/dataentry/manage"
                    render={(props) => <ManageScreens {...props} />}
                    property="MAINTAIN_DATA_SCREENS"
                  />
                  <ProtectedRoute
                    exact path="/dataentry/manage/:id"
                    render={(props) => <ManageScreen {...props} />}
                    property="MAINTAIN_DATA_SCREENS"
                  />
                  <ProtectedRoute
                    path="/dataentry"
                    render={(props) => <Dataentry updateSidebar={updateCcfSummary} {...props} />}
                    property="VIEW_DATA_SCREENS"
                  />
                  <ProtectedRoute
                    exact path="/dashboards/manage"
                    render={(props) => <ManageDashboards {...props} />}
                    property="MAINTAIN_DASHBOARDS"
                  />
                  <ProtectedRoute
                    path="/dashboards/manage/:id"
                    render={(props) => <ManageDashboard {...props} />}
                    property="MAINTAIN_DASHBOARDS"
                  />
                  <ProtectedRoute
                    path="/dashboards"
                    render={(props) => <Dashboards {...props} />}
                    property="VIEW_DASHBOARDS"
                  />
                  <ProtectedRoute
                    path="/report/manage/:id"
                    render={(props) => <ManageReport {...props} />}
                    property="MAINTAIN_REPORTS"
                  />
                  <ProtectedRoute
                    path="/report/manage"
                    render={(props) => <ManageReports {...props} />}
                    property="MAINTAIN_REPORTS"
                  />
                  <ProtectedRoute
                    path="/reports"
                    render={(props) => <Reports {...props} />}
                    property="REPORTS"
                  />
                  <ProtectedRoute
                    exact path="/datagrabber"
                    render={(props) => <Grabber {...props} />}
                    property="DATA_GRABBER"
                  />
                  <ProtectedRoute
                    path="/datagrabber/manage/:id"
                    render={(props) => <ManageGrabber {...props} />}
                    property="MAINTAIN_GRABBERS"
                  />
                  <ProtectedRoute
                    path="/datagrabber/manage"
                    render={(props) => <ManageGrabbers {...props} />}
                    property="MAINTAIN_GRABBERS"
                  />
                  <ProtectedRoute
                    path="/summary"
                    render={(props) => <DataSummary {...props} />}
                    property="REPORTS"
                  />
                  <ProtectedRoute
                    exact path="/parameters"
                    render={(props) => <Parameters {...props} />}
                  />
                  <ProtectedRoute
                    path="/parameters/new"
                    render={(props) => <ParameterForm {...props} />}
                    property="PARAMETERS"
                  />
                  <ProtectedRoute
                    path="/parameters/:code"
                    render={(props) => <ParameterEdit {...props} />}
                    property="PARAMETERS"
                  />
                  <ProtectedRoute
                    path="/parameter/:site/:code"
                    render={(props) => <Parameter {...props} />}
                    property="PARAMETERS"
                  />
                  <ProtectedRoute
                    path="/operations"
                    render={(props) => <Operations {...props} />}
                    property="OPERATIONS"
                  />
                  <ProtectedRoute
                    path="/constants"
                    render={(props) => <Constants {...props} />}
                    property="CONSTANTS"
                  />
                  <ProtectedRoute
                    path="/lookups"
                    render={(props) => <Lookups {...props} />}
                    property="LOOKUPS"
                  />
                  <ProtectedRoute
                    exact path="/users"
                    render={(props) => <Users {...props} />}
                    property="USERS"
                  />
                  <ProtectedRoute
                    path="/users/:id"
                    render={(props) => <UserForm {...props} />}
                    property="USERS"
                  />
                  <ProtectedRoute
                    path="/recalculate"
                    render={(props) => <Recalculate {...props} />}
                    property="PARAMETERS"
                  />
                  <ProtectedRoute
                    path="/logout"
                    component={Logout} />
                  <ProtectedRoute
                    path="/profile"
                    render={(props) => <Profile {...props} />}
                  />
                  <ProtectedRoute
                    path="/notifications"
                    render={(props) => <Notifications {...props} />}
                  />
                  <ProtectedRoute
                    path="/twitter"
                    render={(props) => <Twitter {...props} />}
                    property="PRODUCTION_COMMENTS"
                  />
                  <ProtectedRoute
                    path="/live"
                    render={(props) => <LiveData {...props} />}
                  />
                  <ProtectedRoute
                    path="/processtags"
                    render={(props) => <ProcessTags {...props} />}
                    property="PARAMETERS"
                  />
                  <ProtectedRoute
                    exact path="/ccf"
                    render={(props) => <CCFList updateSidebar={updateCcfSummary} {...props} />}
                    property="VIEW_CCF"
                  />
                  <ProtectedRoute
                    path="/ccf/settings"
                    render={(props) => <CCFSettings {...props} />}
                    property="MAINTAIN_CCF"
                  />
                  <ProtectedRoute
                    path="/ccf/:id/:parmCode"
                    render={(props) => <CCF updateSidebar={updateCcfSummary} {...props} />}
                    property="VIEW_CCF"
                  />
                  <Route path="/login" component={Login} />
                  <Route
                    path="/reset/:id"
                    render={(props) => <ResetForm {...props} />}
                  />
                  <Route path="/reset" component={Reset} />
                  <Route path="/reset/:id" component={ResetForm} />
                  <ProtectedRoute
                    path="/"
                    exact
                    render={(props) => <Home {...props} />}
                  />
                  <ProtectedRoute
                    path="/help"
                    render={(props) => <HelpHome {...props} />}
                  />
                  <Route path="/register" component={Register} />
                  <Route path="/privacy" component={Privacy} />
                  <Route path="/app-help" component={AppSupport} />
                  <Route path="/not-found" component={NotFound} />
                  <Redirect to="/not-found" />
                </Switch>
              </div>
              <CookieConsent
                show={showCookie}
                handleClose={handleAcceptCookies}
              />
              {user && (
                <SiteModal
                  show={showSiteSelection}
                  handleSiteChange={handleSiteChange}
                  onHide={() => setShowSiteSelection(false)}
                />
              )}
            </div>
          </NotificationContext.Provider>
        </AppearanceContext.Provider>
      </SidebarContext.Provider>
    </UserContext.Provider>
  );
};

export default App;
